export default {
      id: "unit_dashboard__check-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.svg#unit_dashboard__check",
      toString: function () {
        return this.url;
      }
    }